import ApiService from '@/core/services/ApiService'
import { useNuxtApp } from '#app';
export const useApiClient = () => {
    const config = useRuntimeConfig();
    const app = useNuxtApp().vueApp;
    ApiService.init(app);
    const apiClient = ApiService.apiClient;
 
    return apiClient
};